require('./loanPartialAmortizationSimulator.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @ helpers
const { formatCurrency } = require('utilities/currencyHelper');
const { buildFormattedDate } = require('utilities/dateHelper');

// @ constants
const currencySimbol = formatCurrency('EUR');
// @ commons
const { formatText, getLanguage } = require('core/i18n').i18n;
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

//@ components
const { AmountInput } = require('commonsComponents/amountInput');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const partialAmortizationActions = require('../../../../actions/loanPartialAmortization');
const { setFeeIndicator, setDueIndicator } = partialAmortizationActions;

// @ constants
const {
    ADVANCE_END_DATE,
    DECREASE_FEE
} = require('../../../../loansConstants/index').amortizationTypes;
// @ constants
const { DATE_FORMAT_ES } = require('constants/index');

class LoanPartialAmortizationSimulator extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isFirstAmountChange: true,
            errorMsg: '',
            hasAmountError: false,
        }

        this.onHandleAmountChange = this.onHandleAmountChange.bind(this);
        this.handleAmortizationTypeChange = this.handleAmortizationTypeChange.bind(this);
    }

    buildSimulationResult() {
        const { partialAmortizationState, newLoanPartialFF } = this.props;
        const simulatorData = partialAmortizationState.get('partialAmortizationSimulationData');
        const detailsData = partialAmortizationState.get('partialAmortizationDetails');
        const amountFinancialLoss = detailsData.perdidaFinanciera ? detailsData.perdidaFinanciera.importe : null;
        const commission = {
            currency: simulatorData.get('commission')
        };
        const financialLoss = {
            currency: amountFinancialLoss
        };
        const percentage = simulatorData.get('percentage');
        const isFetching = simulatorData.get('isFetching');
        const loadingValue = <LoadingSection />;
        const newCommission = isFetching ? loadingValue : (<span className="loan-partial-amortization-simulator__value">{MortgageRequestCurrencyHelp(commission)}</span>);
        const newFinancialLoss = isFetching ? loadingValue : (<span className="loan-partial-amortization-simulator__value">{MortgageRequestCurrencyHelp(financialLoss)}</span>);
        const tooltipContent = formatText('loanPartialAmortization-commissionToolTipContent', [percentage]);
        const tooltipFinancialLostContent = formatText('loanPartialAmortization-financialLostToolTipContent');
        const tooltip = !isFetching && (
            <OKTooltip
                content={tooltipContent}
                offset={[0, -15]}
                title="loanPartialAmortization-commissionToolTipTitle"
                type="explicative"
            />
        );
        const tooltipFinalcialLost = !isFetching && (
            <OKTooltip
                content={tooltipFinancialLostContent}
                offset={[0, -15]}
                type="explicative"
            />
        );
        return (
            <>
                <div className="col-xs-6">
                    <div className="loan-partial-amortization-simulator__result-row">
                        <span className="loan-partial-amortization-simulator__title">
                            {formatText('loanPartialAmortization-commission')}
                            *
                            {tooltip}
                        </span>
                        {newCommission}
                    </div>
                </div>
                {newLoanPartialFF && amountFinancialLoss !== null ?
                    <div className="col-xs-6">
                        <div className="loan-partial-amortization-simulator__result-row">
                            <span className="loan-partial-amortization-simulator__title">
                                {formatText('loanPartialAmortization-financialLoss')}
                                **
                                {tooltipFinalcialLost}
                            </span>
                            {newFinancialLoss}
                        </div>
                    </div>
                    :
                    null
                }
            </>
        );
    }

    handleAmortizationTypeChange(evt) {
        const { updateAmortizationTypeAndSimulateAmortization, immLoan } = this.props;;
        updateAmortizationTypeAndSimulateAmortization(evt.target.value, immLoan);

        this.forceUpdate();
    }

    onHandleAmountChange(value) {
        const { updateAmountAndSimulateAmortization, immLoan, confirmationDetails, partialAmortizationState, newLoanPartialFF } = this.props;
        const balanceAvailableInAccount = Math.abs(partialAmortizationState.get('balance'));
        const parsedValue = isNaN(Number(value)) ? 0 : Number(value);
        const hasAmountError = parsedValue > balanceAvailableInAccount;
        const hasAmountError2 = parsedValue === 0;
        const errorMsg = hasAmountError ? formatText('loanPartialAmortization-amountExceedsBalance') : '';

        this.setState({
            hasAmountError,
            errorMsg
        });

        if (hasAmountError || hasAmountError2) {
            return;
        }

        updateAmountAndSimulateAmortization(parsedValue, immLoan);

        if (this.state.isFirstAmountChange) {
            this.setState({ 
                isFirstAmountChange: false, 
            });
            this.handleAmortizationTypeChange({ target: { value: 'advanceEndDate' } });
            this.handleRadioChange({ target: { value: 'advanceEndDate' } });
        } else if (newLoanPartialFF) {
            confirmationDetails();
        }
    }

    buildRadioButton(id, value, label, descriptionSeleted) {
        const { partialAmortizationState } = this.props;
        const simulatorData = partialAmortizationState.get('partialAmortizationSimulationData');
        const isFetching = simulatorData.get('isFetching');
        const hasAmountError = simulatorData.get('hasAmountError');
        const disabledRadioButtons = isFetching || hasAmountError || !simulatorData.get('amount');
        const isChecked = value === partialAmortizationState.get('selectedRadioButton');

        const classes = classNames('radio-button', {
            'radio-button--disabled': disabledRadioButtons,
        });

        return (
            <div className={classes}>
                <input
                    type="radio"
                    className="radio-button__input"
                    id={id}
                    disabled={disabledRadioButtons}
                    value={value}
                    name={name}
                    checked={isChecked}
                    onChange={this.handleAmortizationTypeChange}
                />
                <label className="radio-button__label" htmlFor={id}>
                    {label}
                </label>
                <div className="loan-partial-amortization-simulator__description-html">
                    {descriptionSeleted}
                </div>
            </div>
        );
    }

    buildDescriptions(simulationType, newFeeValue, newDateValue) {

        const descriptions = {};
        if (simulationType === DECREASE_FEE) {
            descriptions.newFeeHTML = (
                <div className="loan-partial-amortization-simulator__result-row">
                    <span className="loan-partial-amortization-simulator__title">{formatText('loanPartialAmortization-newFeeValue')}</span>
                    {newFeeValue}
                </div>
            );
        } else {
            descriptions.newDateHTML = (
                <div className="loan-partial-amortization-simulator__result-row">
                    <span className="loan-partial-amortization-simulator__title">{formatText('loanPartialAmortization-newDateValue')}</span>
                    {newDateValue}
                </div>
            );
        }
        return descriptions;
    }

    handleRadioChange = (event) => {
        const { setFeeIndicator, setDueIndicator, confirmationDetails, setSelectedRadioButton, newLoanPartialFF } = this.props;
        const { value } = event.target;
        if (value === 'advanceEndDate') {
            setDueIndicator('S');
            setFeeIndicator('N');
        } else if (value === 'decreaseFee') {
            setFeeIndicator('S');
            setDueIndicator('N');
        }
        setSelectedRadioButton(value);

        if (newLoanPartialFF) {
            confirmationDetails();
        }
    };

    buildRatioButtonGroup() {
        const { partialAmortizationState } = this.props;
        const simulatorData = partialAmortizationState.get('partialAmortizationSimulationData');
        const hasRadioGroupError = simulatorData.get('hasRadioGroupError');

        const newFee = {
            currency: simulatorData.get('newFee')
        };
        const newDate = simulatorData.get('newDate');
        const formattedNewDate = buildFormattedDate(newDate, DATE_FORMAT_ES);
        const isFetching = simulatorData.get('isFetching');
        const loadingValue = <LoadingSection />;

        const simulationType = simulatorData.get('amortizationType');
        const newFeeValue = isFetching ? loadingValue : (<span className="loan-partial-amortization-simulator__value">{MortgageRequestCurrencyHelp(newFee)}</span>);
        const newDateValue = isFetching ? loadingValue : (<span className="loan-partial-amortization-simulator__value">{formattedNewDate}</span>);

        let descriptions = {};

        if (simulationType) {
            descriptions = this.buildDescriptions(simulationType, newFeeValue, newDateValue);
        }

        const radioButtonDecreaseFee = this.buildRadioButton('DecreaseFee', DECREASE_FEE, formatText('loanPartialAmortization-decreaseFeeLabel'), descriptions.newFeeHTML);
        const radioButtonAdvanceEndDate = this.buildRadioButton('endDate', ADVANCE_END_DATE, formatText('loanPartialAmortization-advanceEndDateLabel'), descriptions.newDateHTML);

        return (
            <RadioButtonGroup
                name="motive"
                label={formatText('loanPartialAmortization-applyForLabel')}
                idPrefix="cancelChequebookMotiveRadio"
                className="loan-partial-amortization-simulator__radio-group"
                errorState={hasRadioGroupError}
                errorMessage={formatText('loanPartialAmortization-messageError1')}
                onChange={this.handleRadioChange}

            >
                {radioButtonAdvanceEndDate}
                {radioButtonDecreaseFee}
            </RadioButtonGroup>
        );
    }

    render() {
        const { partialAmortizationState } = this.props;
        const simulatorData = partialAmortizationState.get('partialAmortizationSimulationData');
        const amount = simulatorData.get('amount');
        const hasAmountError = this.state.hasAmountError || simulatorData.get('hasAmountError');
        const simulationStarted = simulatorData.get('simulationStarted');
        const simulationResult = amount >= 1 ? this.buildSimulationResult() : null;
        const radioButtonGroup = this.buildRatioButtonGroup(simulatorData);
        const codeError = simulatorData.get('codeError');
        const errorMsg = this.state.errorMsg || (codeError === 1 ? formatText('loanPartialAmortization-messageError2') : '');

        return (
            <div className="row loan-partial-amortization-simulator">
                <div className="col-xs-6">
                    <div className="row">
                        <div className="loan-partial-amortization-simulator__amount col-xs-6">
                            <AmountInput
                                amount={amount}
                                callback={this.onHandleAmountChange}
                                hideFocusZero
                                language={getLanguage()}
                                min={0}
                                name="amortizationAmount"
                                error={hasAmountError}
                                errorMsg={errorMsg}
                                label={formatText('loanPartialAmortization-amortizedAmountLabel')}
                                showBlurZero
                            />
                        </div>
                        <p className="loan-partial-amortization-simulator__currency-symbol col-xs-1">
                            {currencySimbol}
                        </p>
                    </div>
                    {radioButtonGroup}
                </div>
                {simulationStarted && !hasAmountError && simulationResult}
            </div>
        );
    }
}

LoanPartialAmortizationSimulator.propTypes = {
    immLoan: PropTypes.object.isRequired,
    partialAmortizationState: PropTypes.object,
    updateAmountAndSimulateAmortization: PropTypes.func,
    updateAmortizationTypeAndSimulateAmortization: PropTypes.func,
    setFeeIndicator: PropTypes.func,
    setDueIndicator: PropTypes.func,
    confirmationDetails: PropTypes.func,
    setSelectedRadioButton: PropTypes.func,
};

LoanPartialAmortizationSimulator.defaultProps = {

};

module.exports = connect(state => ({
    partialAmortizationState: state.loanPartialAmortization
}), {
    updateAmountAndSimulateAmortization: partialAmortizationActions.updateAmountAndSimulateAmortization,
    updateAmortizationTypeAndSimulateAmortization: partialAmortizationActions.updateAmortizationTypeAndSimulateAmortization,
    setDueIndicator: partialAmortizationActions.setDueIndicator,
    setFeeIndicator: partialAmortizationActions.setFeeIndicator,
    confirmationDetails: partialAmortizationActions.confirmationDetails,
    setSelectedRadioButton: partialAmortizationActions.setSelectedRadioButton,
})(LoanPartialAmortizationSimulator);
